<template>
  <section class="CategoriesList" >
    {{data.categories_list}}
    <SingleCategoryCard  v-for="(item, index) in data.categories" :key="index"
      :image="item.acf.length != 0 ? item.acf.category_image.url : ''"
      :title="item.name"
      link_label='View Collection'
      :link_url="`/product-type/${item.slug}`"
      :description="item.description"
    />

  </section>
</template>

<script setup>
import SingleCategoryCard from '@/components/utility/SingleCategoryCard.vue'
const props = defineProps(['data'])
</script>

<style lang="scss" scoped>
  .CategoriesList{
    @apply px-[10px] md:px-[18px] lg:px-[14px];
  }
</style>
